import React from "react";

export default function StringDatatype({ value, flag }) {
  return (
    <>
      {flag === "error" ? (
        <span style={{ color: "#e8a09d", fontFamily: "Roboto Mono", whiteSpace: 'pre-line' }}>
          "{value}"
        </span>
      ) : (
        <span style={{ color: "#e8a09d", fontFamily: "Roboto Mono" }}>
          "{value}"
        </span>
      )}
    </>
  );
}
